<template>
  <el-row>
    <el-card shadow="never" class="mt-0 card-promo">
      <el-radio-group
        v-model="Promo.promoTargetPaymentMethod.target.targetType"
        style="width: 100%"
      >
        <template v-for="(formradio, idx) in formRadio">
          <el-row :key="idx" type="flex" justify="space-between">
            <el-col :span="6">
              <el-radio :label="formradio.value" class="mt-2">{{ formradio.label }}</el-radio>
            </el-col>
            <el-col :span="14">
              <el-form-item size="small" style="margin: 0">
                <el-row type="flex" justify="space-between" style="flex-wrap: wrap">
                  <template v-for="(form, idx) in formradio.form">
                    <el-col :span="form.span" style="margin-bottom: 18px" :key="idx">
                      <el-input
                        v-if="form.type == 'text' || form.type == 'password' || form.type == 'number'"
                        v-model="Promo.promoTargetPaymentMethod.target[form.id]"
                        :placeholder="form.placeholder"
                        :type="form.type"
                      ></el-input>
                      <el-select
                        v-else-if="form.type == 'select'"
                        v-model="Promo.promoTargetPaymentMethod.target[form.id]"
                        :multiple="form.multiple"
                        style="width: 100%"
                        filterable
                        remote
                        :remote-method="form.onSearch"
                        :loading="form.onLoading"
                      >
                        <el-option
                          v-for="item in form.data"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </template>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-radio-group>
    </el-card>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["Promo"],
  data() {
    return {
      limitPaymentType: 25,
    };
  },
  computed: {
    ...mapState({
      paymentTypes: state => state.paymentType.paymentTypes,
    }),
    formRadio() {
      let paymentTypeDTO = []
      this.paymentTypes.data.map(item => {
        if (['OD-CASH', 'OD-GIRO', 'OD'].includes(item.paymentCode)) {
          if (!paymentTypeDTO.find(x => x.name === 'Cash On Delivery')) {
            paymentTypeDTO.push({
              name: 'Cash On Delivery',
              value: 'OD'
            })
          }
        } else if (['CR CASH', 'CR GIRO', 'CR', 'CN'].includes(item.paymentCode)) {
          if (!paymentTypeDTO.find(x => x.name === 'TOP')) {
            paymentTypeDTO.push({
              name: 'TOP',
              value: 'CR'
            })
          }
        }
        return [];
      });
      paymentTypeDTO.push({
        name: 'Bank Transfer',
        value: 'BT'
      })
      paymentTypeDTO.push({
        name: 'Payment Gateway',
        value: 'PG'
      })
      return [
        {
          label: "Payment Method",
          value: "paymentCode",
          form: [
            {
              type: "select",
              id: "paymentCode",
              label: "",
              rules: [],
              data: paymentTypeDTO.map(item => {
                return item;
              }),
              onSearch: this.onSearchPaymentTypes,
              onLoading: this.paymentTypes.isLoading
            }
          ]
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getPaymentTypes: "paymentType/GetPaymentTypes",
    }),
    onSearchPaymentTypes(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getPaymentTypes(option);
    },
    loadMorePaymentTypes() {
      this.limitCategory += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitCategory,
        }
      };
      this.getPaymentTypes(option);
    },
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getPaymentTypes(option);
  }
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
